import { render } from "./ModificaCollo.vue?vue&type=template&id=2111b887&scoped=true"
import script from "./ModificaCollo.vue?vue&type=script&lang=js"
export * from "./ModificaCollo.vue?vue&type=script&lang=js"

import "./ModificaCollo.vue?vue&type=style&index=0&id=2111b887&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2111b887"]])

export default __exports__